export default __webpack_public_path__ + "static/media/image80.55bcb068.jpg";